import { extractPathIdentifier } from '../../utils/helpers/api-helpers';
import { COMMON_PAGE_PATHS } from '../../constans/url-constants';
import AuthStore from './auth-store';

let authStore: AuthStore | null = null;

const getAuthStore = (): AuthStore => {
  if (authStore == null) {
    authStore = new AuthStore(extractPathIdentifier(COMMON_PAGE_PATHS.PRESENTATION));
  }

  return authStore;
};

export { getAuthStore };